import { ControlIcons } from 'owa-control-icons';
import { OwaDate } from 'owa-datetime';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getListViewNotificationDimensions } from 'owa-mail-list-dimensions';
import * as undoActions from 'owa-mail-undo';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-mail-strings';

/**
 * show notification on schedule
 */
export default function showNotificationOnSchedule(
    allowUndo: boolean,
    scheduleReturnTime?: OwaDate
) {
    if (
        !isFeatureEnabled('tri-notificationBar') ||
        !getUserConfiguration().UserOptions.ShowNotificationBar
    ) {
        return;
    }

    let notificationText: string;
    if (isFeatureEnabled('tri-snooze-exp')) {
        notificationText = scheduleReturnTime ? strings.snoozed : strings.unsnoozed;
    } else {
        notificationText = scheduleReturnTime ? strings.scheduled : strings.unscheduled;
    }
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute('scheduleNotification', notificationText, {
        icon: ControlIcons.Clock,
        primaryActionText: allowUndo ? strings.undoAction : null,

        // Want 12 px of padding on either side of the notification bar
        minWidth: notificationDimensions.minWidth,
        maxWidth: notificationDimensions.maxWidth,
        notificationCallback: (reason: NotificationBarCallbackReason) => {
            if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                undoActions.lazyUndo.importAndExecute('NotificationBar');
            }
        },
    });
}
